import React, { useState } from 'react';
import { Typography } from 'antd';
import DivisionalItemsCard from './DivisionalItemCard';
import DocUploadInFRS from './DocUploadInFR';

const { Title } = Typography;

interface SelectedDivision {
  division: {
    id: string;
    name: string;
    address: string;
    code: string;
    description: string;
    status: string;
    type: string;
    lab_request_types: any;
  };
  labRequestDepartmentId?: number | null;
  alreadyAddedTests: any[];
}
interface LabResultsProps {
  selectedDivisions: SelectedDivision[];
  status: string | null;
  lab_id: number | null;
  tr_type: string | null;
  lab_type: string;
  status_step: string;
}

const LabResultsComponent: React.FC<LabResultsProps> = ({
  selectedDivisions,
  status,
  lab_id,
  tr_type,
  lab_type,
  status_step,
}) => {
  const [divisionsTestsData, setDivisionsTestsData] = useState<Record<string, any[]>>(() => {
    const initialData: Record<string, any[]> = {};
    selectedDivisions.forEach((division) => {
      initialData[division.division.id] = division.alreadyAddedTests;
    });
    return initialData;
  });
  const handleTestsUpdated = (divisionId: string, updatedTests: any[]) => {
    setDivisionsTestsData((prev) => ({
      ...prev,
      [divisionId]: updatedTests,
    }));
  };
  return (
    <div>
      {/* <Title level={4} style={{ marginBottom: 16 }}>
        Lab Tests by Division
      </Title> */}

      {selectedDivisions.length === 0 ? (
        <p>No divisions selected.</p>
      ) : (
        selectedDivisions.map(({ division, labRequestDepartmentId, alreadyAddedTests }) => (
          <DivisionalItemsCard
            key={division.id}
            divisionId={division.id}
            divisionName={division.name}
            divisionCode={division.code}
            status={status}
            lab_id={lab_id}
            context={tr_type}
            alreadyAddedTests={divisionsTestsData[division.id] || alreadyAddedTests}
            status_step={status_step}
            deptId={labRequestDepartmentId}
            lab_type={lab_type}
          />
        ))
      )}

      {status === 'PENDING_FRS' && (lab_type === 'BI-ANNUAL' || lab_type === 'DISEASE_SURVEILLANCE') ? (
        <div style={{ marginTop: 50, marginBottom: 50 }}>
          <Title level={4}>Upload Related Documents</Title>
          <DocUploadInFRS Id={null} />
        </div>
      ) : null}
    </div>
  );
};

export default LabResultsComponent;
